const ru = { 
    serviceCall: 'Поставщик услуг может позвонить',
    heading_request: 'Каковы детали вашего запроса на работу?',
    valid_question1:         'Любые другие детали, которые вы считаете важными?',
    valid_question2:         'Если вы не предоставите достаточно информации. это повлияет на количество цитат, которые вы получите.',
    valid_question3: 'Вы должны ввести не менее 100 букв.',
    image_question: 'Хотите добавить фотографии?',
    where_location: 'Где ? (Место работы)',
    location_validation:         'Мы не можем использовать ваше местоположение. Пожалуйста, найдите город или введите вручную',
    userMyLocation: 'ИСПОЛЬЗУЙТЕ МОЕ МЕСТОПОЛОЖЕНИЕ',
    enterCity: 'Введите название вашего города',
    when_job: 'Когда ? (дата работы)',
    answer_question: 'Хотите ответить на эти вопросы?',
    inputAnswer: 'Введите свой ответ здесь...',
    enterPhone: 'Введите свой телефон',
    phoneDescription:         'Наши специалисты свяжутся с вами быстрее, если вы выберете «Поставщик услуг может звонить».',
    enterPhoneNumber: 'Введите свой номер телефона',
    sendRequest: 'ПОСЛАТЬ ЗАПРОС',
    alert_image: 'Пожалуйста, загрузите хотя бы одно изображение.',
    alert_description: 'Пожалуйста, введите описание.',
    alert_address: 'Пожалуйста, введите свой адрес.',
    alert_one_option: 'Выберите один вариант.',
    alert_pick_date: 'Пожалуйста, выберите дату.',
    alert_answer: 'Пожалуйста, ответьте на вопрос',
    alert_phone: 'Пожалуйста, введите номер телефона.',
    request_success_msg: 'Поздравляем! Вы запросили успешно!',
    alert_close_description:         'Вы можете получить бесплатные цитаты, ответив еще на несколько вопросов.',
    go_on: 'ПРОДОЛЖАТЬ',
    quit: 'ПОКИДАТЬ',
    servicesCompanyReady: "Сервисная компания готова",
    allow_contacts: "Показать мой номер телефона",
    dont_disturbme: "Не беспокой меня",
    only_phone: "Свяжитесь со мной только по телефону",
    only_offers: "Присылайте мне только предложения",
    only_whatsapp: "Свяжитесь со мной только по WhatsApp",
  
    kEmailNullError: "Пожалуйста, введите адрес электронной почты",
    kInvalidEmailError:        "Пожалуйста, введите действительный адрес электронной почты",
    kPassNullError: "Пожалуйста введите ваш пароль",
    kConfirmPasswordError: "Несоответствие пароля",
    kShortPassError: "Пароль слишком короткий, минимум 8 символов",
    kMatchPassError: "Пароли не совпадают",
    kNameNullError: "Пожалуйста введите свое полное имя",
    kPhoneNumberNullError: "Пожалуйста введите ваш номер телефона",

    email: 'Емейл',
    password: 'Пароль',
    pleaseendteryouremail: 'введите ваш емейл',
    pleaseenteryourpassword: 'введите ваш пароль',


    confirmpassword: 'Подтвердите пароль',

    name: 'Имя',
    Congratulation: 'Поздравление',
    requestPriority: 'Приоритет запроса',
    free: 'Бесплатно',
    high: "высокий",

    noSearchResult: 'Нет результата поиска',
    inputThree: 'Пожалуйста, введите не менее 3 букв',

    selected_city: 'Выбранный город(а)',

    specificTime: 'Конкретное время (в течение трех недель)',
    inTwoMonth: 'В течение двух месяцев',
    inSixMonth: 'Через шесть месяцев',
    onlyPrice: 'Просто ищу цену',
    flexibleTime: 'Гибкий',
    asap: 'Как можно быстрее',


    lab_continue: 'Продолжить',

    //CUSTOM
  mainheading: 'Какие виды услуг вы ищете?',
  back: 'Назад',
  serviceErrHead: 'Пустой сервис',
  serviceError: 'Пожалуйста, выберите услугу, которую вы ищете, чтобы продолжить.',

  requiredField: "Обязательное поле",
  requireDesc: 'Это поле является обязательным.'
}

export default ru;